import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';

@Injectable({
  providedIn: 'root',
})
export class FilteringService {
  //safely translate enum value or return null if not valid in case someone fiddled in url so we dont get errors
  safeCastEnum<T extends object>(enumType: T, value: unknown): T[keyof T] | null {
    const values = Object.values(enumType) as unknown[];
    return values.includes(value) ? (value as T[keyof T]) : null;
  }

  safeCastEnumArray<T extends object>(enumType: T, value: string | null): T[keyof T][] {
    if (!value) {
      return [];
    }

    const enumValues = Object.values(enumType);
    const values = value
      .split(',')
      .map(v => decodeURIComponent(v.trim()))
      .filter(v => v !== '' && v !== 'null');

    return values.filter(v => enumValues.includes(v as T[keyof T])) as T[keyof T][];
  }

  safeCastIntToEnum<T extends Record<string, number>>(enumType: T, value: number): T[keyof T] | null {
    const enumValues = Object.values(enumType) as number[];
    return enumValues.includes(value) ? (value as T[keyof T]) : null;
  }
  safeCastSortDirection(value: string, defaultValue: SortDirection = 'asc'): SortDirection {
    if (value === 'asc' || value === 'desc') {
      return value;
    }
    return defaultValue;
  }
  safeCastSortBy(value: string, defaultVal: string): string {
    if (value && value.length > 0) {
      return decodeURIComponent(value);
    }
    return decodeURIComponent(defaultVal);
  }
}
